import React, { Component }     from "react";
import uniqueId                 from 'lodash/uniqueId';
import { Button, DropdownButton, FormGroup, MenuItem, Modal, FormControl, ControlLabel, Row, Col } from "react-bootstrap";
import LoaderButton             from "../../components/LoaderButton";
import ModalSimple              from "../../components/modal/ModalSimple";
import ModalChangeBlockName     from "../../components/modal/ModalChangeBlockName";
import ModalSaveBlock           from "../../components/modal/ModalSaveBlock";
import ModalAddBlockTemplate    from "../../components/modal/ModalAddBlockTemplate";
import CreateMonthViewWeek      from "./CreateMonthViewWeek";
import ModalYouTubeVideo        from "../../components/modal/ModalYouTubeVideo";
import ModalExerciseMatrix      from "../../components/modal/ModalExerciseMatrix";
import ModalProgramOverview     from "../../components/modal/ModalProgramOverview";
//import SortableDayViewBlockList from "../../components/sortable/SortableDayViewBlockList";
import { ExerciseFreeFormId }   from "../../utils/StaticIds";
import CreateDayView            from "./CreateDayView"
import ModalAlert               from "../../components/modal/ModalAlert";
import ModalSearchKeywords      from "../../components/modal/ModalSearchKeywords";
import ModalEditBlockName       from "../../components/modal/ModalEditBlockName";
import SideNavTimelineWeek      from "../../components/utils/SideNavTimelineWeek";
import { Colors }               from "../../utils/Colors";

import { sortBlockObjectFromDayView
         //sortBlockObjectFromMonthView,
       } from "../../utils/ObjectSort";

import { invokeCreateProgramDay,
         invokeDeleteProgramDay,
         invokeDuplicateProgramDay,
         invokeDuplicateProgramDay_v2, //test
         invokeGetSingleProgram,        ////  USER SELECTS A SINGLE DAY FROM THE PROGRAM MONTH VIEW  ////
         invokeCreateProgramWeek,
         invokeDeleteProgramWeek,
         invokeDuplicateProgramWeek,
         invokeUpdateBlockFromMonthView,
         invokeSetUpdateFullProgramFromDayView,
         invokeGetProgramSingleDayView,
         invokeGetExerciseDetail,
         invokeSetTemplateTitle,
         invokeSetAddMonthViewNewExercise,
         invokeGetEditMonthViewExercise,
         invokeSetEditMonthViewExercise,
         invokeSetAddFreeFormBlockMonthView,
         invokeSetAddNewBlockMonthView,
         invokeGetProgramOverview,
         invokeGetSingleBlockTemplate
       } from "../../utils/AwsInvoke";

import { deleteExerciseObjectProps,
         editExerciseObjectProps,
         addSingleBlockToProgram,
         addNewBlock,
         duplicateBlock,
         deleteBlockObject,
         addNewAdvancedExercise,
         editAdvancedExercise,
         addNewFreeFormObject
       } from "../../utils/Object";
import "../../css/Program.css";
import "../../css/misc/FontAwesomeIcons.css";

//const uuidv1 = require('uuid/v1');
const baseBlockBtnXPos          = 0;
const baseBlockBtnYPos          = 0;
const showExerciseDetails       = "Show Exercise Details";

const initialState = {
    isLoading:         null,
    isDeleting:        null,
    note:              null,
    program_name:      "",
    program_block:     [""],
    //program_id:        null, // do not reset program_id!
    week_id:           null,
    weeks_id_order:    null,
    days_id_order:     null,
    weeks:             [""],
    days:              [""],
    monthViewDayId:   1,
    monthViewBlockId: null,
    exercise_id:       "",
    exercise_name:     "",
    rest:              0,
    youtube_id:        null,
    notes:             null,
    exercise_index:    null,
    showModalSimple:   false,
    show_day_view:     "none",
    showModalChangeBlockName: false,
    showModalSaveBlock: false,
    showModalAddBlockTemplate: false,
    showModalSearchKeywords: false,
    showModalEditBlockName: false,
    showExerciseDetailRow: "none",//"inherit",
    modalSimpleAction:     "duplicate",
    blockBtnGrpPosition:   "relative",
    blockBtnGrpXPos:        baseBlockBtnXPos,
    blockBtnGrpYPos:        baseBlockBtnYPos,
    showExerciseDetailsRowLabel: showExerciseDetails,
    loadingText:           "Loading",
    loadingBarContainer:   "none", // show loading bar
    cssWeekContainerHeight: 720, //400,560,720
    month_view_program_block: null,
    loadMonthViewData: false,
    showModalExerciseMatrix: false,
    showYouTubeModal: false,
    youTubeId: "",
    edit_title: false,
    showModalProgramOverview: false,
    zoomLevel: 4
};

export default class Program extends Component {

    constructor(props) {
        super(props);

        this.file = null;
        this.state = {
            isLoading:         null,
            isDeleting:        null,
            note:              null,
            program_name:      "",
            program_block:     [""],
            program_id:        null,
            week_id:           null,
            weeks_id_order:    null,
            days_id_order:     null,
            weeks:             [""],
            days:              [""],
            monthViewDayId:   1,
            monthViewBlockId: null,
            exercise_id:       "",
            exercise_name:     "",
            rest:              0,
            youtube_id:        null,
            notes:             null,
            exercise_index:    null,
            showModalSimple:   false,
            showModalChangeBlockName:  false,
            showModalSaveBlock:        false,
            showModalProgramOverview:  false,
            showModalAddBlockTemplate: false,
            showExerciseDetailRow: "none",//"inherit",
            modalSimpleAction:     "duplicate",
            blockBtnGrpPosition:   "relative",
            blockBtnGrpXPos:        baseBlockBtnXPos,
            blockBtnGrpYPos:        baseBlockBtnYPos,
            showExerciseDetailsRowLabel: showExerciseDetails,
            show_day_view:         "none",
            loadingBarContainer:   "none", // show loading bar
            //// Views can't be stored in the Initial State Or they get overwritten ////
            showMonthView:         "inherit",
            showDayView:           "none", // default program view
            cssWeekContainerHeight: 720, //400, 560, 720
            month_view_program_block: true,
            loadMonthViewData: false,
            showModalExerciseMatrix: false,
            showYouTubeModal: false,
            youTubeId: "",
            edit_title: false,
            zoomLevel: 4,

            modalAlertTitleText: "",
            modalAlertBodyText:  "",
            showModalAlert:      false, // true | false
            alertObject:         {},
            alertAction:         "",
        };
        this.handleBackButton = this.handleBackButton.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
    }

    reset() {
        this.setState(initialState);
    }


    handleScroll (event) {
        let scrollYPos = window.scrollY;

        this.setState({
            scrollYPos: scrollYPos
        });
    }

    handleBackButton = (event) => {
        var state = event.state;

        if (state !== null)
            window.history.go(1);
    }

    componentDidUpdate(){
        // Don't Need to Remove the OnPopState event because it's attached to the Window, not a DOM el
        window.onpopstate  = (e) => {
            var showDayView = this.state.showDayView;

            if(showDayView === "inherit") {
                this.handleBackButton(e)
                this.showMonthView()
            }
        }
    }

    componentDidMount() {
        console.log("Program.js component did mount!");
        // set initial day but don't reset after every save or instantiation

        // Check if program_id is valid, otherwise the page will auto-load
        // because of the <router> used in the side navbar component
        //if(program_id != "list") {

        // begin temp 12/5 - SHOW MODAL IMMEDIATELY UPON COMPONENT LOAD //
        /*var block_index = "0"
        var day_id = "8191ae12-0c11-11ea-99f9-bf5ba945c552";
        var block_id = "81925650-0c11-11ea-a645-0b2a584d2872";
        this.openAddNewExerciseModal(block_index, day_id. block_id);*/
        // end temp //

            this.setState({
                program_id: `${this.props.match.params.id}`,
                isTemplate: `${this.props.match.params.is_template}`,
                clientName: `${this.props.match.params.client_name}`,
                clientId: `${this.props.match.params.client_id}`,
                day_current: 1,
                week_current: 1
            }, function() {
                // no program_block yet so debug shows nothing: this.debugAdvView(this.state.program_block); // data integrity
                // this.getProgramData (); this causes 2 simultaneous http requests; 1. from month view component and 2. invokeGetSingleProgram
            });
        //}

        //// Used for the SideNavBar Timeline ////
        window.addEventListener('scroll', this.handleScroll);
    }

    //// Used for the SideNavBar Timeline ////
    componentWillUnmount () {
        //window.onpopstate = () => {} // reset OnPopState
         window.removeEventListener('scroll', this.handleScroll);
    }

    componentWillReceiveProps() {
        //console.log("Program.js componentWillReceiveProps");

        this.setState({
            program_id: `${this.props.match.params.id}`,
        })
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    showLoadingFooter = (value) => {
        this.setState({
            loadingBarContainer: value
        })
    }

    showMonthView () {
        //this.changeProgramView("month", null, null);
        this.setState({
            showDayView: "none",
            showMonthView: "inherit",
            week_current: 1
        }, function() {
            this.getProgramData();
        })
    }

    getProgramData = async event => {

        console.log("++++++++++++   getProgramData!!!!");
        try {
                // Reset Day View ONLY if user is actually wanting to view the Day
                if(this.state.showMonthView != "inherit") {

                    this.showLoadingFooter("inherit");
                    this.setState({
                        loadingText: "Loading"
                    })

                    var results = await this.getDayViewProgramData();

                    this.reset();
                    this.renderDayViewProgramData(results);
                    console.log(" END Get Program Data ---------");
                } else if(this.state.showMonthView === "inherit") {
                    console.log("RESET MONTH VIEW!!!");
                    //this.resetMonthView();
                }
        } catch (e) {
            alert("Program data error: " + e);
            this.showLoadingFooter("none");
        }
    }

    ////  A DAY IS SELECTED FROM THE DAY VIEW DROPDOWN  /////
    getSingleDayViewProgramData = async (week_id) => {
        var program_id = this.state.program_id;
        return await invokeGetProgramSingleDayView(program_id, week_id)
    }

    ////  USER SELECTS A SINGLE DAY FROM THE PROGRAM MONTH VIEW  ////
    getDayViewProgramData = async () => {
        this.showLoadingFooter("inherit");
        var program_id   = this.state.program_id;
        var week_id      = this.state.week_id;
        var week_current = this.state.week_current;
        var day_current  = this.state.day_current;
        var day_id       = this.state.day_id;
        //console.log("*************** invokeGetSingleProgram GET DATA ***************");

        return await invokeGetSingleProgram(program_id, week_id, week_current, day_id, day_current);
    }

    renderDayViewProgramData (results) {

        var program_block = results.program_block;

        this.setState({
            exerciseNotes:  results.exercise_notes,
            program_name:   results.program_name,
            weeks_id_order: results.weeks_id_order,
            days_id_order:  results.days_id_order, // days order & days id
            day_id:         results.program_day_id,
            week_id:        results.program_week_id,
            week_current:   results.program_week_current,
            program_block:  results.program_block
        }, function() {
            this.showLoadingFooter("none");
            // this.debugAdvView(program_block);
        });
    }

    showCurrentDayTab(current_day) {
        this.setState({day_current: current_day}); //this.getNextDay()})
    }

    showCurrentWeekTab() {
        this.setState({week_current: this.getNextWeek()})
    }

    getNextDay() {
        //console.log("this.state.days_id_order: " + this.state.days_id_order);
        var total_days = Object.keys(this.state.days_id_order).length;
        var day_next   = total_days + 1;
        return day_next;
    }

    getNextWeek() {
        var total_weeks;
        if(this.state.weeks_id_order === null)
            total_weeks = 0;
        else
            total_weeks = Object.keys(this.state.weeks_id_order).length;

        var week_next   = total_weeks + 1;

        return week_next;
    }

    setProgramWeekId = (week_id) => {
        this.setState({
            week_id: week_id
        })

    }

    createProgramDay  = async (week_id, last_day) => {
        this.showLoadingFooter("inherit");
        this.setProgramWeekId(week_id);

        var show_day_view = this.state.showDayView;
        var program_id    = this.state.program_id;

        const results = await invokeCreateProgramDay(program_id, week_id, last_day) //this.getNextDay());

        if(results.status) {

            if(show_day_view != "none") {
                var day_id = results.new_day_id;
                this.changeDayViewSingleDay(day_id, last_day)
            } else {
                this.showCurrentDayTab(last_day)
                this.resetMonthView(); // REFRESH MONTH VIEW AFTER CREATING A DAY //
            }
            this.showLoadingFooter("none");
        } else
            this.showLoadingFooter("none");
    }

    createProgramWeek  = async event => {
        var program_id    = this.state.program_id;

        this.showLoadingFooter("inherit");
        const results = await invokeCreateProgramWeek(program_id, this.getNextWeek());

        var show_day_view = this.state.showDayView;

        if(results.new_week_id != null) {
            var week_id      = results.new_week_id;
            var day_id      = results.new_day_id;

            if(show_day_view != "none") {
                console.log("---- REDIRECT to DAY View ----");
                this.showCurrentWeekTab()
                var week_current = this.state.week_current;

                this.setState({ weeks_id_order: results.weeks_id_order, week_id: week_id, week_current: this.getNextWeek(), day_id: day_id, day_current: 1},
                    function() {
                        this.getProgramData();
                    }
                )
            } else {
                console.log("---- REDIRECT to MONTH View ----");
                this.resetMonthView();
                this.oneSecondTimer();
            }
            this.showLoadingFooter("none");
        }
    }

    oneSecondTimer = () => {
        var setInt = setInterval(timer, 800);
        var that = this;
        function timer() {
            clearInterval(setInt);
            that.scrollToBottomOfPage();
        }
    }

    resetMonthView() {
        console.log("LOAD MONTH VIEW DATA...");
        this.setState({
            loadMonthViewData: true //reset month view
        }, function(){
            this.setState({
                loadMonthViewData: false, // immediately after setting month view: true, set to false or it will cycle and refresh continuously
                loadingBarContainer: "none"
            })
        });
    }

    duplicateProgramWeekFromMonthView(week_id) {
        this.showLoadingFooter("inherit");
        this.setState({
            week_id: week_id
        }, function(){
            this.duplicateProgramWeek();
        })
    }

    deleteProgramWeekFromMonthView(week_id) {
        this.showLoadingFooter("inherit");
        this.setState({
            week_id: week_id
        }, function(){
            this.deleteProgramWeek();
        })
    }

    deleteProgramWeek = async event => {

        this.showLoadingFooter("inherit");
        var show_day_view = this.state.showDayView;
        var week_id       = this.state.week_id;
        var program_id    = this.state.program_id;
        const results     = await invokeDeleteProgramWeek(program_id, week_id);

        if(results.status === true) {

            if(show_day_view != "none") {
                console.log("---- REDIRECT to DAY View ----");
                // Restart Program from Day 1 //
                this.setState({week_current: 1, day_current: 1}, function() {
                    this.getProgramData();
                });
            } else {
                this.resetMonthView();
            }
            //this.showLoadingFooter("none");
        } else
            this.showLoadingFooter("none");
    }

    deleteProgramDay  = async event => {
        this.showLoadingFooter("inherit");
        var week_id       = this.state.week_id;
        var day_id        = this.state.day_id;
        var day_current   = 1;
        var days_id_order = this.state.days_id_order;
        var day1_id = days_id_order[0].uid;
        var total_days = Object.keys(days_id_order).length;

        if(total_days === 1) {
            var title_text = "Warning"
            var body_text  = "Sorry, you can't delete the last day of the week.";
            this.setModalAlertProps(title_text, body_text, true); // title_text, body_text, show_modal
            this.showLoadingFooter("none");
            return false;
        }
        console.log("Delete Program Day >>>>>>>>");
        //this.startTimer();
        const results = await invokeDeleteProgramDay(week_id, day_id);

        if(results.status === true) {
            console.log("Finished: Delete Program Day");
            // Restart Program from Day 1 //
            this.changeDayViewSingleDay(day1_id, day_current);
            //this.showLoadingFooter("none");
        } else
            this.showLoadingFooter("none");
    }

    validateForm() {
        return this.state.program_name.length > 0;
    }

    formatFilename(str) {
        return str.length < 50
          ? str
          : str.substr(0, 20) + "..." + str.substr(str.length - 20, str.length);
    }

    handleChangeProgramName = event => {

        var text      = event.target.value;
        var check_str = text.includes("/");

        if(check_str) {
            var title_text = "Info"
            var body_text  = "Sorry, you can't add a '/' to the program title.";
            this.setModalAlertProps(title_text, body_text, true); // title_text, body_text, show_modal

            return false;
        }

        this.setState({
          [event.target.id]: text,
          edit_title: true
        });
    }

    handleChangeWeekName = event => {
        this.setState({
          [event.target.id]: event.target.value
        });
    }

    handleChangeDayName = event => {
        this.setState({
          [event.target.id]: event.target.value
        });
    }

    handleFileChange = event => {
        this.file = event.target.files[0];
    }

    debugAdvView(program_block) {

        //console.log("********************* BEGIN DEBUG VIEW!!! ***********************");

        for(var key2 in program_block) {
                /*var prog_block    = program_block[key2];
                var category_id   = prog_block.category_id;
                var block_id      = prog_block.block_id;
                var block_order   = prog_block.block_order;
                var week_id       = prog_block.week_id;
                var week_order    = prog_block.week_order;
                var day_id        = prog_block.day_id;
                var day_order     = prog_block.day_order;

                var exercise      = prog_block.exercise;
                var exerc_lgth    = prog_block.exercise_lgth;
                console.log(">>>>>>>> WEEK order: " + week_order + " <<<<<<<<<<<");
                console.log("category_id: " + category_id);
                console.log("Block id: " + block_id);
                console.log("Block order: " + block_order);
                console.log("week_id: " + week_id);
                console.log("week_order: " + week_order);
                console.log("day_id: " + day_id);
                console.log("exercise: " + exercise);
                console.log("exerc_lgth: " + exerc_lgth);
                console.log("-------  key  -------");/* */

                /*for(var key3 in exercise) {
                    console.log("key3: " + key3);
                    var exer            = exercise[key3];
                    var exer_name       = exer.name;
                    var exer_id         = exer.id;
                    var youtube_id      = exer.youtube_id;
                    var notes           = exer.notes;
                    console.log("exer_name: " + exer_name);
                    console.log("exer_id: " + exer_id);
                }

                //console.log("********** ADV Rows ************");
                /*for(var e = 0; e < block_lgth; e++) {

                    var exer_id         = block.exercise[e].id;
                    var exer_order      = (e+1);//block.exercise[e].order;
                    var set_id          = block.exercise[e].set_id;
                    var notes           = block.exercise[e].notes;

                    //var advanced_metrics = block.exercise[e].advanced_metrics;

                    /*var row_measure_1_id   = 0;// Row is always Set block.exercise[e].row_1_id;
                    var row_measure_2_id   = block.exercise[e].row_2_id;
                    var row_measure_3_id   = block.exercise[e].row_3_id;
                    var row_measure_4_id   = 3;// Row 4, id 3 is always rest
                    // Measureable IDs
                    var row_measure_1   = block.exercise[e].row_1_arr;
                    var row_measure_2   = block.exercise[e].row_2_arr;
                    var row_measure_3   = block.exercise[e].row_3_arr;
                    var row_measure_rest= block.exercise[e].row_4_arr;
                } /* */
        } /* */
        //console.log("*********************** END DEBUG VIEW!!! ***********************");
        //console.log(" ");
    }

    saveFullProgramFromDayView = async () => {
        var program_id    = this.state.program_id;
        var program_block = this.state.program_block;
        var title         = this.state.program_name;
        var week_id       = this.state.week_id;
        var week_current  = this.state.week_current;
        var day_id        = this.state.day_id;
        var day_current   = this.state.day_current;

        //console.log(":::::::::::::::::: SAVE PROGRAM then with title ---> " + title);
        /*console.log("program_id: " + program_id);
        console.log("week_id: " + week_id);
        console.log("day_id: " + day_id);
        console.log("day_current: " + day_current);
        console.log("week_current: " + week_current);
        console.log("program_block: " + program_block);*/
        // this.debugAdvView(program_block);

        return await invokeSetUpdateFullProgramFromDayView(program_id, program_block, title, week_id, week_current, day_id, day_current);
    }

    setUpdateBlockFromMonthView = async () => {
        var title         = this.state.program_name;
        var program_id    = this.state.program_id;
        var program_month_block = this.state.month_view_program_block;

        //this.debugAdvView(program_month_block);
        /*for(var key in program_month_block) {
            var tmp_day_id = program_month_block[key].day_id;
            var tmp_week_id = program_month_block[key].week_id;
            // should not be undefined below
            //console.log("tmp_week_id: " + tmp_week_id);
            //console.log("tmp_day: " + tmp_day_id);/* /
        }*/

        var program_id    = this.state.program_id;
        //console.log("::::::::::: SAVE PROGRAM FROM MONTH VIEW ::::::::::::");
        //console.log("program_id: " + program_id);
        //this.debugAdvView(program_month_block);

        //if(monthViewDayIds != undefined) { // monthViewDayIds: used on the back-end to delete Day Ids only; no inserts
        return await invokeUpdateBlockFromMonthView(title, program_id, program_month_block);

        /* */
            //return false;
        //} else  return false;
    }

    invokeSortDaysMonthViewProgram = (order, week_id) => {
        //console.log("<<<<<<<<<<<<<<<<<<< Invoke Save MONTH VIEW Program >>>>>>>>>>>>>>>>>>>>>");
        var program_id    = this.state.program_id;
    }

    updateMonthViewProgramBlock = (program_block, callback) => {
        //console.log("---------- DEBUG and updateMonthViewProgramBlock --------");
        //this.debugAdvView(program_block); // test data integrity

        this.setState({
            month_view_program_block: program_block
        }, () => {
            callback("completed")
        });/* */
    }

    setProgramName = (program_name, weeks_id_order) => {

        this.setState({
            program_name: program_name,
            weeks_id_order: weeks_id_order
        })
    }

    handleEditTemplateTitle = (event) => {
        event.preventDefault();

        this.saveTemplateTitle();
    }

    saveTemplateTitle = async event => {
        var program_id  = this.state.program_id;
        var title       = this.state.program_name;
        var results = await invokeSetTemplateTitle(program_id, title);

        if(results.status) {
            this.setState({ isLoading: false, edit_title: false });
        }
    }

    saveProgram = async event => {
        this.setState({ isLoading: true });

        var show_day_view = this.state.showDayView;
        var results;

        try {
            this.showLoadingFooter("inherit");

            if(show_day_view != "none") {
                results = await this.saveFullProgramFromDayView();
            } else {
                // If there is no user interaction on the page at all but a user clicks the save btn, it will be null...avoid this with if()
                if(this.state.month_view_program_block != null) {
                    console.log("Save program results from MONTH VIEW ------- ");
                    results = await this.setUpdateBlockFromMonthView();
                }
            }

            //console.log("Save program results from MONTH VIEW: " + results.status);
            if(results.status) {
                //this.debugAdvView(this.state.program_block);
                this.resetMonthView(); // 11.11.19: force a month view reset so the data loads properly
            }

            // temp remove so page doesn't go to root after every save....
            this.showLoadingFooter("none");
            // temp add
            this.setState({ isLoading: false, edit_title: false }); // need to add a return function to stop the isLoading button icon
        } catch (e) {
            alert("Saving Program error: " + e);
            this.setState({ isLoading: false, edit_title: false });
            this.showLoadingFooter("none");
        }
    }

    handleDelete = async event => {
        event.preventDefault();

        const confirmed = window.confirm("Are you sure you want to delete this program?");

        if (!confirmed) {
            return;
        }

        this.setState({ isDeleting: true });

        try {
            this.showLoadingFooter("inherit");
            var results = await this.deleteProgram();

            if(results.status) this.setState({ isDeleting: false });

            this.props.history.push("/");
            this.showLoadingFooter("none");
        } catch (e) {
            alert("Delete program error: " + e);
            this.setState({ isDeleting: false });
            this.showLoadingFooter("none");
        }
    }

    handleDeleteExercise = (block_id, set_id) => { //block_index, exercise_index
        this.showLoadingFooter("inherit");
        var programObj  = this.state.program_block;

        var tmpObj = deleteExerciseObjectProps(programObj, block_id, set_id); // block_index,exercise_index

        this.setState({
            program_block: tmpObj
        }, function() {
            this.quickSaveAndGetProgramData();
        });
    }

    /*editProgramBlock = (tmpObj) => {
        this.setState({
            program_block: tmpObj
        }, function() {
            this.quickSaveAndGet ProgramData();
        });
    }*/

    quickSaveAndGetProgramData = async () => {
        console.log("++++++++++++++   Bgin: quickSaveAndGetProgramData");
        this.setState({
            loadingText: "Saving"
        })
        const results = await this.saveFullProgramFromDayView();
        console.log("++++++   End: quickSaveAndGetProgramData   +++++++");
        if(results.status) {
            // console.log(" Start get Program Data ---------");
            // begin: added 6/19/20
            // this.showLoadingFooter("none");
            // this.setState({ showModalSimple: false })
            // end //

            // temp remove 6/19/2020:
            this.getProgramData();
        }
    }

    handleEditAdvancedExercise (block_index, exercise_index, exercise_id, exercise_name, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes) {

        var programObj    = this.state.program_block;
        var new_row_3_arr = row_3_arr;
        var tmpBlockObj   = editAdvancedExercise(programObj, block_index, exercise_index, exercise_id, exercise_name, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, new_row_3_arr, row_4_arr, exercise_notes);

        // Show Overlay so user dosnt add data and then have it erased once the new data is loaded ...
        this.showLoadingFooter("inherit");

        this.setState({
            program_block: tmpBlockObj,
            showModalSimple: false
        }, function() {
            // temp remove 6/19/20
            // uncommented out 9/3/20
            this.quickSaveAndGetProgramData();
        });
    }

    handleEditAdvancedExerciseMonthView = async (block_index, exercise_id, exercise_name, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes) => {

        var current_set_id = this.state.monthViewSetId; // used to delete existing measures and values so the new ones can be inserted into the db
        var program_id     = this.state.program_id;
        var day_id         = this.state.monthViewDayId;
        var block_id       = this.state.monthViewBlockId;
        var exercise_order = this.state.monthViewExerciseOrder;
        var results        = await invokeSetAddMonthViewNewExercise("editExistingExerciseData", program_id, day_id, block_id, current_set_id, exercise_id, exercise_order, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes);

        if(results.status) {
            this.resetMonthView();
            this.setState({
                monthViewDayId: null,   // reset day_id
                monthViewBlockId: null, //reset block_id
                monthViewSetId: null,   // reset set_id
                monthViewExerciseOrder: null,
                showMonthView: "inherit",
                isLoading: false,
                loadingBarContainer: "none",
                showModalSimple: false
            })
        }
    }

    handleEditMonthViewExercise = async (day_id, block_index, block_id, set_id, exercise_id, exercise_order, exercise_name) => {
        /*console.log("---- handleEditMonthViewExercise !!!");
        console.log("---- set_id: " + set_id);
        console.log("---- exercise_order: " + exercise_order);*/
        var program_id = this.state.program_id;

        this.setState({ isLoading: true, loadingBarContainer: "inherit" });
        var results = await invokeGetEditMonthViewExercise(program_id, set_id, exercise_id);

        if(results.status) {
                var row_ids = results.data.row_ids;
                var row_ids_arr = row_ids.toString().split(",")
                var row_1 = results.data.row_1_arr;
                var row_2 = results.data.row_2_arr;
                var row_3 = results.data.row_3_arr;
                var row_4 = results.data.row_4_arr;

                var row_1_arr = JSON.parse("[" + row_1 + "]");
                var row_2_arr = JSON.parse("[" + row_2 + "]");
                var row_3_arr = JSON.parse("[" + row_3 + "]");
                var row_4_arr = row_4.toString().split(",")


                var exercise_index      = null;           // we don't use exerc index in month view
                var measure_2_id        = row_ids_arr[1]; // array starts at element 0
                var measure_3_id        = row_ids_arr[2]; // don't need measure 1 or measure 4 since it's "set #" and "rest" measures
                var rest                = null;           // no need to set value here; this var is set elsewhere
                var notes               = results.data.notes; // needed for client programs and free-form exercises
                var exercise_notes      = results.data.exerciseNotes;
                var advanced_metrics    = [row_1_arr, row_2_arr, row_3_arr, row_4_arr];
                var youtube_id          = null; // not necessary
                var modal_simple_action = "editFromMonthView"; // perm

                if(exercise_id === ExerciseFreeFormId)
                    modal_simple_action = "freeFormEditBlockFromMonthView";


                this.setState({
                    exerciseNotes: exercise_notes,
                    monthViewDayId: day_id,
                    monthViewBlockId: block_id,
                    monthViewSetId: set_id,
                    monthViewExerciseOrder: exercise_order,
                    isLoading: false,
                    loadingBarContainer: "none"
                }, function() {
                    this.showDayModalSimple(true, exercise_index, block_index, exercise_id, exercise_name, measure_2_id, measure_3_id, rest, notes, modal_simple_action, advanced_metrics, youtube_id);
                });
        }
    }

    handleAddAdvancedExercise = async (index, exercise_id, exercise_name, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes) => {

        this.setState({ isLoading: true, loadingBarContainer: "inherit" });

        // MUST CLEAR BLOC ID AFTER adding new exercise data //
        if(this.state.showMonthView === "inherit") {
                var current_set_id = null; // no need to set this for new exercises
                var program_id     = this.state.program_id;
                var day_id         = this.state.monthViewDayId
                var block_id       = this.state.monthViewBlockId
                var exercise_order = 0;
                var results        = await invokeSetAddMonthViewNewExercise("addNewExerciseData", program_id, day_id, block_id, current_set_id, exercise_id, exercise_order, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes);

                if(results.status) {
                    this.resetMonthView();
                    this.setState({
                        monthViewDayId: null,   // reset day_id
                        monthViewBlockId: null, // reset block_id
                        monthViewSetId: null,   // reset set_id
                        showMonthView: "inherit",
                        isLoading: false,
                        loadingBarContainer: "none",
                        showModalSimple: false
                    })
                }
        } else {
                console.log("Add New Exercise from da Modal ++++++++++++++");
                //this.startTimer();
                var programObj  = this.state.program_block;
                var tmpBlockObj = addNewAdvancedExercise(programObj, index, exercise_id, exercise_name, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes);

                this.setState({
                    program_block: tmpBlockObj
                }, function(){
                    this.hideSimpleModalAndOverlay();
                    // temp remove 6/19/20:
                    // uncommented out 9/3/20
                    this.quickSaveAndGetProgramData();
                });
        }
    }

    hideSimpleModalAndOverlay () {
        this.showLoadingFooter("none");
        this.setState({ showModalSimple: false })
    }

    startTimer () {
        var seconds = 0;
        setInterval(function() {
        console.log("seconds: " + seconds++);
        }, 1000);
    }

    handleAddFreeFormExercise = async (block_index, exercise_index, exercise_id, notes) => {
        //console.log("block_index, exercise_index, exercise_id, notes: " + block_index + " - " + exercise_index+ " - " + exercise_id+ " - " + notes);
        this.showLoadingFooter("inherit");

        // MUST CLEAR BLOC ID AFTER adding new exercise data //
        if(this.state.showMonthView === "inherit") {
                var day_id  = this.state.monthViewDayId;
                var results = await invokeSetAddFreeFormBlockMonthView(day_id, exercise_index, exercise_id, notes);
                if(results.status) {
                    this.resetMonthView();
                    this.showLoadingFooter("none");

                    this.setState({
                        showModalSimple: false
                    })
                }

        } else {
                var programObj = this.state.program_block;
                var tmpBlockObj = addNewFreeFormObject(programObj, block_index, exercise_index, exercise_id, notes);

                this.setState({
                    program_block: tmpBlockObj,
                    showModalSimple: false
                }, function(){
                    this.quickSaveAndGetProgramData();
                });
        }
    }

    handleAddExerciseNotes = async (block_index, exercise_index, exercise_id, notes) => {
        /*var programObj = this.state.program_block;
        var tmpBlockObj = addNewFreeFormObject(programObj, block_index, exercise_index, exercise_id, notes);

        this.setState({
            program_block: tmpBlockObj
        }, function(){
            this.quickSaveAndGetProgramData();
        });*/
    }

    // replace with DB
    tempGetCategory(index) {
        var tmp_arr = ["Foam Roll","Correctives","Prep","Slate","Strength","ESD"];
        var el = tmp_arr[index-1];
        return el;
    }

    createNewBlock () {
        var program = this.state.program_block;
        var block_index   = Object.keys(program).length;

        // Add next Block in the object's order //
        var tmpBlockObj = addNewBlock(program);

        this.setState({
            program_block: tmpBlockObj,
        }, function() {
            // auto show modal if new block:
            // this.setState({ showModalSimple: true, exercise_index: null, block_index: block_index.toString(), exercise_id: 0, exercise_name: "",rest: 0, notes: "", modalSimpleAction: "duplicate" })
        });
    }

    handleAddBlock = async (action, day_id) => {
        if(action === "addMonthViewBlock") {

            var results = await invokeSetAddNewBlockMonthView(day_id);
            if(results.status) {
                this.resetMonthView();
                this.showLoadingFooter("none");
            }
        } else
            this.createNewBlock();
    }

    handleAddBlockTemplate = async (action, day_id) => {
        console.log("handleAddBlockTemplate*************");
        this.setState({
        //    block_id:    block_id,
        //    block_name:  block_name,
            showModalAddBlockTemplate: true
        })
        /*if(action === "addMonthViewBlock") {

            var results = await invokeSetAddNewBlockMonthView(day_id);
            if(results.status) {
                this.resetMonthView();
                this.showLoadingFooter("none");
            }
        } else
            this.createNewBlock();*/
    }

    handleAddFreeFormBlock = (action, day_id) => {

            if(action === "addMonthViewBlock") {
                    var block_index = 0; // block index does not matter in month view
                    var notes         = "";
                    this.openAddFreeFormExercise (block_index, ExerciseFreeFormId, "Free-Form", notes, day_id)
            } else {
                    var program = this.state.program_block;

                    // Add next Block in the object's order //
                    var tmpBlockObj   = addNewBlock(program);
                    var block_index   = Object.keys(program).length-1; // -1 because Program array starts at 0 element
                    //var exercise_id   = ExerciseFreeFormId; // Free-Form Id
                    var exercise_name = "Free-Form"
                    var notes         = "";
                    var day_id        = null; //not needed for adding a free form block to day view
                    this.setState({
                        program_block: tmpBlockObj,
                    }, function() {
                        this.openAddFreeFormExercise (block_index, ExerciseFreeFormId, exercise_name, notes, day_id)
                    });
            }
    }

    openAddFreeFormExercise (index, exercise_id, exercise_name, notes, day_id) {
        this.setState({ showModalSimple: true, exercise_index: null, block_index: index.toString(),
                        exercise_id: exercise_id, exercise_name: "Free Form", measure_2_id: 0, measure_3_id: 0, rest: 0, youtube_id: null,
                        notes: "", modalSimpleAction: "freeFormNewBlock",
                        advanced_metrics: "", monthViewDayId: day_id }) // day_id is only needed in monthview
    }

    handleEditBlockName = (block_index, block_name) => {
        this.showLoadingFooter("inherit");

        var tmpObj  = this.state.program_block;
        tmpObj[block_index].block_name = block_name;

        this.setState({
            program_block: tmpObj,
        }, function(){
            this.quickSaveAndGetProgramData();
        });
    }

    handleDeleteBlock = (index) => {
        this.showLoadingFooter("inherit");
        var programObj = this.state.program_block;

        delete programObj[index]; // delete row
        // Remove empty elements from array i.e. {},,,{},{}
        // var block_arr = block.filter(value => Object.keys(value).length !== 0);
        // Re-order the newly structured block_order property after prop deletion (ie order: 0,2,3,4 => 0,1,2,3)
        //block_arr = this.reorderObjects(block_arr);

        var tmpObj = deleteBlockObject(programObj);

        this.setState({
            program_block: tmpObj
        }, function(){
            this.quickSaveAndGetProgramData();
        });
    }

    handleAddBlockTemplateToProgram = async(block_id) => {
        console.log("handleAddBlockTemplateToProgram ---------------- ");
        this.showLoadingFooter("inherit");
        const results = await invokeGetSingleBlockTemplate(block_id);

        if(results.status) {

            var block_template = results["results"].single_block;
            var programObj     = this.state.program_block;
            let tmpBlockObj    = addSingleBlockToProgram(block_template, programObj);
            var blockObj       = Object.assign(programObj, tmpBlockObj);

            this.setState({
                program_block: blockObj,
            }, function(){
                this.quickSaveAndGetProgramData();
            });
        } else
            alert("Ooops, looks like there was an error. Try again.");
    }

    handleDuplicateBlock = (index) => {
        //console.log("index: " + index);
        this.showLoadingFooter("inherit");
        var programObj  = this.state.program_block;
        let tmpBlockObj = duplicateBlock(index, programObj);
        var blockObj    = Object.assign(programObj, tmpBlockObj);

        this.setState({
            program_block: blockObj,
        }, function(){
            this.quickSaveAndGetProgramData();
        });
    }

    /*********** END DAY VIEW: BLOCK FUNCTIONS **********/

    /*********** MONTH VIEW: BLOCK FUNCTIONS **********/

    /*handleDuplicateBlockFromMonthView(index) {
        this.showLoadingFooter("inherit");
        var programObj  = this.state.program_block;
        //let tmpBlockObj = this.duplicateBlockFromMonthView(index, programObj);
        //var blockObj    = Object.assign(programObj, tmpBlockObj);
        //var blockObj    = Object.assign(programObj, tmpBlockObj);

        this.setState({
            program_block: programObj //blockObj
        });
    }

    duplicateBlockFromMonthView(index, block_id) {
        console.log("duplicateBlock block_id: " + block_id);

        // Need WEEK #, Day # then Block #
        var programObj = this.state.program_block;
        delete programObj[index]; // delete row
        // Remove empty elements from array i.e. {},,,{},{}
        // var block_arr = block.filter(value => Object.keys(value).length !== 0);
        // Re-order the newly structured block_order property after prop deletion (ie order: 0,2,3,4 => 0,1,2,3)
        //block_arr = this.reorderObjects(block_arr);

        //var tmpObj = this.deleteBlockObjectFromMonthView(programObj);

        //this.setState({
        //    program_block: tmpObj
        //});/
    }*/

    handleSaveBlock = async (block_id, block_name) => {

        //this.showLoadingFooter("inherit"); // this adds the overlay before the modal appears
        this.setState({
            block_id:    block_id,
            block_name:  block_name,
            showModalSaveBlock: true
        })
        console.log("handleSaveBlock!!!!!!!!!");
        console.log("block_id: " + block_id);
        console.log("block_name: " + block_name);
    }

    handleSaveBlockTemplate = (block_index, block_name) => {
        console.log("handleSaveBlockTemplate *******");
        /*this.showLoadingFooter("inherit");

        var tmpObj  = this.state.program_block;
        tmpObj[block_index].block_name = block_name;

        this.setState({
            program_block: tmpObj,
        }, function(){
            this.quickSaveAndGetProgramData();
        });*/
    }


    duplicateProgramDay  = async event => {
        console.log("DAYVIEW duplicateProgramDay !!!");
        this.showLoadingFooter("inherit");
        var week_id    = this.state.week_id;
        var day_id     = this.state.day_id;
        var total_days_in_week = Object.keys(this.state.days_id_order).length;

        // test comment out 6/19/20: const results = await invokeDuplicateProgramDay(day_id, week_id, total_days_in_week);
        console.log("Progra.js invokeDuplicateProgramDay_v2 ...");
        const results = await invokeDuplicateProgramDay_v2(day_id, week_id, total_days_in_week);
        //const results = await invokeDuplicateProgramDay(day_id, week_id, total_days_in_week);

        if(results.status === true) {
                console.log("done duplicating the program day ...");

                // Set Current Day to the Duplicated Day
                this.setState({ day_id: results.day_id, day_current: results.day_current, days_id_order: results.days_id_order}, () => {
                    // test remove 6/19/20:
                    // takes too long: this.getProgramData();
                    // wipes out data: this.reset();
                    // don't use: this.changeDayViewSingleDay(results.day_id, results.day_current)

                    this.showCurrentDayTab(results.day_current);

                    this.showLoadingFooter("none");
                });

        } else {
            this.showLoadingFooter("none");
        }
    }

    duplicateProgramWeek  = async event => {

        this.showLoadingFooter("inherit");

        const results = await this.setDuplicateProgramWeek();
        var show_day_view = this.state.showDayView;

        if(results.status === true) {
            console.log("--------- DUPLICATE WEEK!");
            if(show_day_view != "none") {
                console.log("---- REDIRECT to DAY View ----");
                var day_id       = results.day_id;
                var week_id      = results.week_id;
                var week_current = results.week_current;

                // Set Current Week to the Duplicated Week
                this.setState({ week_id: week_id, week_current: week_current, day_id: day_id, day_current: 1}, () => {
                    this.getProgramData();
                    //this.showCurrentDayTab();
                    this.showLoadingFooter("none");
                });
            } else {
                console.log("---- REDIRECT to MONTH View ----");
                this.resetMonthView();
                this.showLoadingFooter("none");
                this.oneSecondTimer(); // temp sol: must set timer to wait until the dom loads
            }
        } else
            this.showLoadingFooter("none");
    }

    scrollToBottomOfPage = () => {
        window.scrollTo(0, document.body.scrollHeight - 900);
    }

    setDuplicateProgramWeek = async () => {
        var program_id  = this.state.program_id;
        var week_id     = this.state.week_id;
        var total_weeks = Object.keys(this.state.weeks_id_order).length;
        var week_next   = total_weeks + 1;


                        console.log("program_id: " + program_id);
                        console.log("week_id: " + week_id);
                        console.log("week_current: " + week_next);

        return await invokeDuplicateProgramWeek(program_id, week_id, week_next)
    }

    getDayFromMonthView (day_current, day_id, curr_week, curr_week_id) {

            this.setState({
                week_current: curr_week,
                week_id: curr_week_id
            }, function(){
                this.changeProgramView("day", day_id, day_current);

                this.setState({day_current: day_current, day_id: day_id}, function() {
                    this.getProgramData();
                })
            })
    };

    showProgramListView (section) {
        var url = `/${section}/list/${this.state.clientId}/&/${this.state.clientName}`;
        this.props.history.push(url);
    }

    showGeneralProgramListView(section) {
        //this.props.history.goBack();
        var url = '/programs/list';
        this.props.history.push(url);
    }

    changeDayViewSingleDay = (day_id, day_current) => {
            this.setState({day_current: day_current, day_id: day_id}, function() {
                this.getProgramData();
            })
    }

    handleDayDropdownChange = async (eventKey, day_current, day_id) => {

        this.showLoadingFooter("inherit");
        this.changeProgramView("day", day_id, day_current);

        const results = await this.saveFullProgramFromDayView();

        if(results.status) {
            this.setState({day_current: day_current, day_id: day_id}, function() {
                if(eventKey == 0) {
                    this.getProgramData();
                } else if(eventKey == 1) {
                    // Create New Day
                    this.createProgramDay();
                } else if(eventKey == 2) {
                    // Duplicate Day option
                    this.duplicateProgramDay();
                } else if(eventKey == 3) {
                    // Delete Day option
                    this.deleteProgramDay();
                }
            })
            this.showLoadingFooter("none");
        } else
            this.showLoadingFooter("none");
    }

    handleWeekDropdownChange = async (eventKey, week_current, week_id) => {
        this.showLoadingFooter("inherit");
        const results = await this.saveFullProgramFromDayView();

        if(results.status) {
            /////!!!! FIX: if week ID is the same don't need to fetch new days id data
            const results2 = await this.getSingleDayViewProgramData(week_id); // Day View
            var day1_id = results2.day1_id;
            console.log(">>>>>>>>>>> day1_id " + day1_id);

            this.setState({week_current: week_current, week_id: week_id, day_id: day1_id, day_current: 1}, function() { // day_current = 1 to restart every week on day 1
                if(eventKey == 0) {
                    console.log("********** DROPDOWN WEEK ---------------");
                    console.log("week_current: " + week_current);
                    console.log("week_id: " + week_id);
                    console.log("day_id: " + day1_id);
                    this.getProgramData();

                    invokeGetProgramSingleDayView
                } else if(eventKey == 1) {
                    // Create New Week
                    this.createProgramWeek();
                } else if(eventKey == 2) {
                    // Duplicate Day option
                    this.duplicateProgramWeek();
                } else if(eventKey == 3) {
                    // Delete Week option
                    this.deleteProgramWeek();
                }
            })
            this.showLoadingFooter("none");
        } else
            this.showLoadingFooter("none");
    }

    /************* WEEKVIEW TABS FOR DAYVIEW *************/
    renderWeekListTabs () {
        const curr_week = this.state.week_current;
        var weeks       = this.state.weeks_id_order;
        var week_tabs;

        if(weeks != null)
            week_tabs =  Object.keys(weeks).map(function (key) {
                                var week_num = parseInt(key) + 1;
                                var week_id = weeks[key].uid;
                                var day;
                                var weight       = "normal";
                                var borderBottom = "0px";
                                var activeDay;
                                //console.log("Day #: "+ week_num + "  >  day id: " + week_id);
                                if (curr_week === week_num) {
                                        weight       = "bold";
                                        borderBottom = "3px solid #efefef";
                                        activeDay = <span className = "dropdownWeekContainer">
                                                        <DropdownButton
                                                          bsSize    = "large"
                                                          title     = ""
                                                          id        = "dropdown-size-large"
                                                          className = "dropdownWeekCaret"
                                                          style = {{backgroundColor: "#fff"}}
                                                          onSelect={(eventKey) => this.handleWeekDropdownChange(eventKey, week_num, week_id)}
                                                        >
                                                                { /*}<MenuItem eventKey="1">Add Week</MenuItem>
                                                                <MenuItem divider />*/ }
                                                                <MenuItem eventKey="2">Duplicate Week</MenuItem>
                                                                <MenuItem divider />
                                                                <MenuItem eventKey="3">Delete Week</MenuItem>
                                                        </DropdownButton>
                                                    </span>
                                    }

                                if (curr_week === week_num) weight    = "bold";
                                        return (
                                            <span key={uniqueId()}>
                                                <Button className   = "dropdownGeneral"
                                                        id          = "dropdown-size-large"
                                                        style       = {{fontWeight: weight, borderBottom: borderBottom, backgroundColor: "#fff"}} // this style isnt effective in className
                                                        onClick    = {() => this.handleWeekDropdownChange(0, week_num, week_id)}>
                                                            {"Week " + week_num}
                                                </Button>

                                                { activeDay }
                                            </span>
                                        )
                                }, this)

        return week_tabs;
    }

    /*renderDayListTabs () {
        const curr_day = this.state.day_current;
        var days       = this.state.days_id_order;
        var day_tabs;
        //console.log("days state: " + days);

        if(days != null) {
            day_tabs =  Object.keys(days).map(function (key) {
                            var day_num = parseInt(key) + 1;
                            var day_id = days[key].uid;
                            var day;
                            var weight       = "normal";
                            var borderBottom = "0px";
                            var activeDay;
                            //console.log("DAY key: " + key);
                            if (curr_day === day_num) {
                                    weight       = "bold";
                                    //borderBottom = "3px solid #f4cd43";
                                    activeDay = <span className = "dropdownDayContainer">
                                                    <DropdownButton
                                                      bsSize    = "large"
                                                      title     = ""
                                                      id        = "dropdown-size-large"
                                                      className = "dropdownDayCaret"
                                                      style     = {{backgroundColor: "transparent"}}
                                                      onSelect={(eventKey) => this.handleDayDropdownChange(eventKey, day_num, day_id)}
                                                    >
                                                            <MenuItem eventKey="2">Duplicate Day</MenuItem>
                                                            <MenuItem divider />
                                                            <MenuItem eventKey="3">Delete Day</MenuItem>
                                                    </DropdownButton>
                                                </span>
                                }

                            if (curr_day === day_num) weight    = "bold";
                                    return (
                                        <span key={uniqueId()} >
                                            <Button className   = "dropdownGeneral"
                                                    id          = "dropdown-size-large"
                                                    style       = {{fontWeight: weight, backgroundColor: "transparent", borderBottom: "0px solid #fff"}} // this style isn't effective in className
                                                    onClick    = {() => this.handleDayDropdownChange(0, day_num, day_id)}>
                                                        {"Day " + day_num}
                                            </Button>

                                            { activeDay }
                                        </span>
                                    )
                        }, this)
            }

        return day_tabs;
    }*/

    addNewWeekFromMonthView = () => {
        // Create New Week
        this.createProgramWeek();
    }

    addNewWeekFromDayView() {
        // Create New Week
        this.createProgramWeek();
    }

    showProgressOverlay = (arg) => {
        if(arg)
            this.showLoadingFooter("inherit");
        else
            this.showLoadingFooter("none");
    }

    handleChangeBlockName = (block_id, index, block_name) => {
        //this.showLoadingFooter("inherit"); // this adds the overlay before the modal appears
        this.setState({
            block_index: index,
            block_id:    block_id,
            block_name:  block_name,
            showModalChangeBlockName: true
        })
    }

    showDayModalSimple = (showModalSimple, index, block_index, exercise_id, exercise_name, measure_2_id, measure_3_id, rest, notes, modal_simple_action, advanced_metrics, youtube_id) => {

        this.setState({ showModalSimple: showModalSimple, exercise_index: index, block_index: block_index,
                        exercise_id: exercise_id, exercise_name: exercise_name, measure_2_id: measure_2_id, measure_3_id: measure_3_id,
                        rest: rest, notes: notes,  modalSimpleAction: modal_simple_action,
                        advanced_metrics: advanced_metrics, youtube_id: youtube_id, /*[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]*/
                        //exerciseNotes: notes // 11.16.19 - temp solution;  exerciswNotes and notes is the same prop
                    })
    }

    ////// Day_id AND Block_id is only passed along in the monthview when adding a new exercise
    openAddNewExerciseModal = (index, day_id, block_id) => {
        var orig_block_id = block_id;
        var orig_day_id   = day_id;
        // don't forget to clear the block_id if not on monthview
        if(this.state.showMonthView != "inherit") {
            orig_block_id = null;
            orig_day_id   = null;
        }


        // Open Modal with preset values //
        this.setState({ monthViewBlockId: orig_block_id, monthViewDayId: orig_day_id,  // this row of data not used in modal simple
                        showModalSimple: true, exercise_index: null, block_index: index,
                        exercise_id: 0, exercise_name: "",
                        rest: 0, notes: "", modalSimpleAction: "duplicate",
                        advanced_metrics: [[0],[0],[0],["00:00"]], /*[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]*/
                        measure_2_id: 2, measure_3_id: 12 }) // 2: Reps , 12: % of Max
    }

    sortBlocksOnDayView = (blocks_exercs_order_arr, blocks_order, exercise_order, day_id_to) => { // rem: day_id
        //console.log("----------------  sortBlocksOnDayView  ----------------");
        var programObj = this.state.program_block;

        var tmpObj = sortBlockObjectFromDayView(programObj, blocks_exercs_order_arr, blocks_order, exercise_order, day_id_to); // rem: day_id

        for(var key in programObj) {
                var value        = programObj[key];
                var day_id       = value.day_id;

                // fetch the week and day order
                if(day_id_to === day_id) {
                    var match_week_id    = value.week_id;
                    var match_week_order = value.week_order;
                }
        }

        this.setState({
            program_block: tmpObj
        }, function() {
            this.saveProgram();
        });
    }

    showAllExerciseDetailRows() {
        var exerciseLabel = showExerciseDetails;
        var exerciseDisplay = "none"

        if(this.state.showExerciseDetailRow === "none") {
            exerciseDisplay = "inherit",
            exerciseLabel   = ""; // Temp remove - hide Exercise Details"
        }
        this.setState({
            showExerciseDetailRow: exerciseDisplay,
            showExerciseDetailsRowLabel: exerciseLabel
        })
    }

    changeProgramView = (view, tmp_day_id, tmp_day_current) => {
        var month_view  = "none";
        var day_view    = "none";
        var day_current = null;
        var day_id      = null;

        if(view === "month")
            month_view = "inherit";
        else {
            day_id      = tmp_day_id;
            day_current = tmp_day_current;
            day_view    = "inherit";
        }

        this.setState({
            showMonthView: month_view,
            showDayView: day_view,
            day_current: day_current,
            day_id: day_id
        })
    }

    /*getAllBlockIdsOnDayView () {
        var program_block  = this.state.program_block;
        var tmp_arr = [];
        var blocksList = Object.keys(program_block).map( index => {
                    var value     = program_block[index];
                    var block_id  = value.block_id;
                    tmp_arr.push(block_id)
        })

        return tmp_arr;
    }*/

    setWeekContainerHeight(new_height) {
        var curr_height = this.state.cssWeekContainerHeight;
        if(curr_height == new_height) {
            // do nothing
        } else if(new_height === 400) {
            this.setState({zoomLevel: 2, cssWeekContainerHeight:400});
        } else if(new_height === 560) {
            this.setState({zoomLevel: 3, cssWeekContainerHeight:560});
        } else if(new_height === 720) {
            this.setState({zoomLevel: 4, cssWeekContainerHeight:720});
        } else
            this.setState({zoomLevel: 1, cssWeekContainerHeight:43});
    }

    getProgramDOMTree = (lastExerciseOrBlockOrDay, error_code) => {

        //console.log("lastExerciseOrBlockOrDay: " + lastExerciseOrBlockOrDay);
        //console.log("error_code: " + error_code);
            console.log("****** GET PROGRAM DOM TREE *******");
            var tmpObj = {};
            var ff_exists_in_arr = false;
            var list = document.getElementsByClassName("Programs");

            // Root Hierarchy: programs > form > trackMonthViewContainer > trackMonthViewParent > trackMonthViewWeekContainer2 > trackMonthViewWeek > trackWeekMainBox > trackMonthViewDayBox > trackMonthViewDay > trackMonthViewDayBlockList
            for (var i = 0; i < list.length; i++) {
                //console.log(list[i]);
                var nodes = list[0].children[0].childNodes; // list[0].children[0] = programs > form > ...
                var numberOfFormNodes = nodes.length; //getElementsByClassName("trackMonthViewContainer trackMonthViewWeekContainer1 trackMonthViewWeekContainer2")
                var numberOfWeeks     = document.querySelectorAll('.weekMainContainer').length;

                ////  Get ALL weeks in the program via ".weekMainContainer"  ////
                var week_nodes = document.querySelectorAll('.weekMainContainer');
                var n_ctr = 0

                for (var i = 0; i < week_nodes.length; i++) {
                    //console.log(">>>>>>>>> wEEK: " + i);
                    var week_id      =  week_nodes[i].attributes.getNamedItem("week_id").value;
                    var week_num     =  week_nodes[i].attributes.getNamedItem("id").value;
                    var days_in_week = week_nodes[i].querySelectorAll('.weekMainSingleDay');
                    //console.log("Days In WEEK: " + days_in_week.length);
                    var week_order_ctr     = i+1; // week order starts at 1


                    for (var j = 0; j < days_in_week.length; j++) {
                            var blocks_container = days_in_week[j].querySelectorAll('.trackExerciseContainer');
                            var blocks_in_days = blocks_container[0].childNodes;
                            var day_id =  days_in_week[j].attributes.getNamedItem("day_id").value;
                            var day_order_ctr = j+1; // day order starts at 1
                            // trackExerciseContainer (i.e. blocks_in_days[0]) will always have access to children at [0]
                            console.log(j + ". Blocks_in_days.length:  " + blocks_in_days.length);
                            for (var k = 0; k < blocks_in_days.length; k++) {
                                var exers_in_blocks = blocks_in_days[k].querySelectorAll('.trackBlockContainer')[0].childNodes;
                                var exerc_lgth = exers_in_blocks.length;

                                var block_id   = blocks_in_days[k].attributes.getNamedItem("block_id").value;
                                var block_name = "";
                                var block_order_ctr = k+1; // block order starts at 1

                                if(blocks_in_days[k].attributes.getNamedItem("block_name") != undefined)
                                    block_name = blocks_in_days[k].attributes.getNamedItem("block_name").value;

                                tmpObj[n_ctr] = {};
                                tmpObj[n_ctr].week_id       = week_id;
                                tmpObj[n_ctr].week_order    = week_order_ctr; // week order starts at 1
                                tmpObj[n_ctr].day_id        = day_id;
                                tmpObj[n_ctr].day_order     = day_order_ctr; // day order starts at 1
                                tmpObj[n_ctr].block_id      = block_id;
                                tmpObj[n_ctr].block_order   = block_order_ctr; // block order starts at 1
                                tmpObj[n_ctr].block_name    = block_name;
                                tmpObj[n_ctr].exercise_lgth = exerc_lgth;
                                tmpObj[n_ctr].exercise      = {};

                                var ex_ctr = 0;
                                var tmp_ff_arr = [];
                                console.log("++++ Exerc_lgth: " + exerc_lgth);
                                for (var l = 0; l < exerc_lgth; l++) {

                                    var exer_name = exers_in_blocks[l].innerHTML;
                                    var exer_id   = exers_in_blocks[l].getAttribute("ex_id");
                                    var set_id    = exers_in_blocks[l].getAttribute("set_id");
                                    var notes     = exers_in_blocks[l].getAttribute("notes");
                                    var exercise_order_ctr = l+1; // exercise order starts at 1
                                    console.log(l + ". exer_name: " + exer_name);
                                    if(exer_name != undefined && exer_name != "") {
                                            tmpObj[n_ctr].exercise[ex_ctr]            = {};
                                            tmpObj[n_ctr].exercise[ex_ctr].name       = exer_name;
                                            tmpObj[n_ctr].exercise[ex_ctr].set_id     = set_id;
                                            tmpObj[n_ctr].exercise[ex_ctr].id         = exer_id;
                                            tmpObj[n_ctr].exercise[ex_ctr].order      = exercise_order_ctr;
                                            tmpObj[n_ctr].exercise[ex_ctr].notes      = notes;
                                            ex_ctr++;

                                            // check if free-form exists in array //
                                            tmp_ff_arr.push(exer_id);
                                    }

                                    // Conditional: Check if Free-Form exerc exists in array //
                                    // If FF exists, reset DOM tree and do not allow drag n' drop
                                    if(tmp_ff_arr.length > 1) {
                                        var contains_ff = tmp_ff_arr.indexOf(ExerciseFreeFormId);
                                        if(contains_ff != -1) ff_exists_in_arr = true;
                                    }
                                } // end 'l' for loop

                                n_ctr++;
                            } // end 'k' for loop

                            console.log("------------- End Program DOM Tree -----------------");
                    }
                }
            }



            ////  If it's the last Exercise or Block or Day do not apply new Sort Object  ////
            if(!lastExerciseOrBlockOrDay && !ff_exists_in_arr) {
                console.log("tmpObj length: " + tmpObj.length);
                this.setState({
                    month_view_program_block: tmpObj
                }, function() {
                    // 11.11.19 temp remove save button:
                    // start here
                    this.saveProgram();
                });
            } else {
                ////  Reset Program Block if it's the Last Exercise in a Block or Block in a Day  ////
                ////  ie the sort resets itself back to the original preset order
                this.setState({
                     program_block: this.state.program_block
                })

                var body_text;

                if(lastExerciseOrBlockOrDay){
                    if(error_code === 1)
                        body_text = "Sorry, you can't move the last block in a day.";
                    else if (error_code === 2)
                        body_text = "Sorry, you can't drag an exercise into a Free-Form block.";
                    else if (error_code === 3)
                        body_text = "Sorry, you can't drag a Free-Form exercise. Try dragging the block instead.";
                    else if (error_code === 4)
                        body_text = "Sorry, you can't move the last exercise in a block.";
                    else
                        body_text = "Sorry, you can't move this exercise.";

                    this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
                } else if(ff_exists_in_arr) {
                    body_text = "Sorry, you can't move an exercise into or out of a Free-Form block.";
                    this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
                }
            }
    }

    handleOpenExerciseMatrix = () => {
        this.setState({
            showModalExerciseMatrix: true
        })
    }

    handleCloseYouTubeWin = () => {
        this.setState({
            showYouTubeModal: false
        });
    }


    handleOpenModalSearchKeywords = () => {
        this.setState({
            showModalSearchKeywords: true
        })
    }

    handleOpenModalEditBlockName = (block_name, block_id) => {
        this.setState({
            showModalEditBlockName: true,
            block_id: block_id,
            block_name: block_name,
            showModalAddBlockTemplate: false
        })
    }
    handleFinishedModalEditBlockName = () => {
        this.setState({
            showModalEditBlockName: false,
            showModalAddBlockTemplate: true
        })
    }

    showYouTubeVideoModal = async (event, exercise_id, yt_id) => {
        var details_obj = {};

        const results = await invokeGetExerciseDetail(exercise_id);
        //details_obj.exercise_id = exercise_id;
        details_obj.name      = results.data.exercise_data[0].name;
        details_obj.start     = results.data.exercise_data[0].start;
        details_obj.execute   = results.data.exercise_data[0].execute;
        details_obj.focus     = results.data.exercise_data[0].focus;
        details_obj.goal      = results.data.exercise_data[0].goal;

        if(results) {
            this.setState({
                youTubeId: yt_id,
                pageOverlay: "inline",
                showYouTubeModal: true,
                exerciseDetailsObj: details_obj
            })
        }
    }

    setExerciseProps = (exercise_id, exercise_name) => {
        this.setState({
            exercise_id: exercise_id,
            exercise_name: exercise_name,
            showModalExerciseMatrix: false
        })
    }

    showProgramOverview = async () => {
        console.log("showProgramOverview!!!!");
        var program_id   = this.state.program_id
        var results      = await invokeGetProgramOverview(program_id);

        this.setModalProgramOverviewProps("Program Overview", program_id); // title_text, body_text, show_modal
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalProgramOverviewProps = (title_text, program_id) => {

        this.setState({
            modalTitleText: title_text,
            modalProgramId:  program_id,
            showModalProgramOverview:  true, // true | false
        })
    }

    /*handleSubmitModalAddBlockTemplate = async (block_id) => {
        console.log("handleSubmitModalAddBlockTemplate block_id : " + block_id);

        this.setState({
            showModalAddBlockTemplate: false
        })
        const results = await invokeGetSingleBlockTemplate(block_id);

        if(results.status) {
            var block_template = results["results"].single_block;
            console.log("block_template: " + block_template);
            this.handleAddBlockTemplateToProgram(block_template);
        } else
            alert("Ooops, looks like there was an error adding the saved block. Try again.")
    }*/

    render() {
        var program_id = `${this.props.match.params.id}`;
        //console.log("[[[[[[[[[[[[[[[[    RENDER PROGRAM    ]]]]]]]]]]]]]]]]");
        //this.getProgramDOMTree(); // test function

        // Check if program_id is valid, otherwise the page will auto-load
        // because of the <router> used in the side navbar component
        if(program_id != "list") {

            var program_block = this.state.program_block;
            var ctr2          = 1;
            var week_id       = this.state.week_id;
            var week_current  = this.state.week_current;
            var weeks         = this.state.weeks_id_order;
            var day_id        = this.state.day_id;
            var day_current   = this.state.day_current;
            var days_id_order = this.state.days_id_order
            var client_name   = this.state.clientName;
            // If New Day [0] was created, add New Block

            if(program_block[0] == undefined) {
                this.createNewBlock();
            }

            var buttonShowExerciseDetails;

            /////   BEGIN: Is user coming from the Templates or Member Programs Section?   /////
            var tmp_url_str = this.props.location.pathname;
            var sub_str = tmp_url_str.match("/(.*)/");
            var section;
            var breadcrumb_url = <span onClick={() => this.showGeneralProgramListView(section)}>Templates </span>

            if(sub_str != null) section = sub_str[1].substr(0, sub_str[1].indexOf('/'));
            if(section === "client") {
                breadcrumb_url = <span onClick={() => this.showProgramListView(section)}>Member: {client_name}</span>;
            }
            /////    END   /////

            // showGeneralProgramListView
            var showMonthViewLink = <span className="monthViewBreadCrumbTrail">
                                        <span className="changeMonthViewText">
                                                &nbsp; <span className="glyphicon glyphicon-align-justify"></span>
                                            &nbsp; { breadcrumb_url }
                                        </span>
                                        <span> &nbsp;>&nbsp;</span>
                                        <span>
                                                &nbsp; <span className="glyphicon glyphicon-calendar"></span> Month View
                                        </span>
                                    </span>


            if(this.state.showDayView === "inherit") {
                buttonShowExerciseDetails = <Button
                                                //className="programNavFooterBtn"
                                                style={{backgroundColor: "transparent", outline: "none", border: 0}}
                                                onClick={() => this.showAllExerciseDetailRows()}
                                            >
                                               { /*Hide exercise detail view: this.state.showExerciseDetailsRowLabel*/ }
                                            </Button>

                showMonthViewLink = <span className="monthViewBreadCrumbTrail">
                                        <span className="changeMonthViewText">
                                                &nbsp; <span className="glyphicon glyphicon-calendar"></span>
                                                &nbsp;{ breadcrumb_url }
                                        </span>
                                        <span> &nbsp;>&nbsp;</span>
                                        <span className="changeMonthViewText" onClick={() => this.showMonthView()}>
                                                &nbsp; <span className="glyphicon glyphicon-calendar"></span> Month View
                                        </span>
                                        <span> &nbsp;> &nbsp;Day View </span>
                                    </span>
            }

            var showDayViewContainer;

            if(this.state.showMonthView != "inherit") {
                    /* var test_obg_lgth = Object.keys(program_block).length

                         Object.keys(program_block).map( index => {
                                    var value      = program_block[index];
                                    var block_name = value.block_name;
                                    var block_id   = value.block_id;

                    })*/

                    showDayViewContainer = <CreateDayView program_block = { program_block }
                                                          week_id       = { week_id }
                                                          week_current  = { week_current }
                                                          day_id        = { day_id }
                                                          day_current   = { day_current }
                                                          days_id_order = { days_id_order }
                                                          showDayView   = { this.state.showDayView }
                                                          debugAdvView  = { this.debugAdvView }
                                                          handleAddBlockTemplate  = {this.handleAddBlockTemplate}
                                                          handleSaveBlock         = {this.handleSaveBlock}
                                                          getProgramDOMTree       = {this.getProgramDOMTree}
                                                          changeDayViewSingleDay  = {this.changeDayViewSingleDay}
                                                          duplicateProgramDay     = {this.duplicateProgramDay}
                                                          deleteProgramDay        = {this.deleteProgramDay}
                                                          addNewWeekFromDayView   = {this.addNewWeekFromDayView}
                                                          createProgramDay        = {this.createProgramDay}
                                                          handleAddBlock          = {this.handleAddBlock}
                                                          handleAddFreeFormBlock  = {this.handleAddFreeFormBlock}
                                                          handleChangeBlockName   = {this.handleChangeBlockName}
                                                          handleDeleteExercise    = {this.handleDeleteExercise}
                                                          showDayModalSimple      = {this.showDayModalSimple}
                                                          sortBlocksOnDayView     = {this.sortBlocksOnDayView}
                                                          handleDuplicateBlock    = {this.handleDuplicateBlock}
                                                          handleDeleteBlock       = {this.handleDeleteBlock}
                                                          handleDayDropdownChange = {this.handleDayDropdownChange}
                                                          openAddNewExerciseModal = {this.openAddNewExerciseModal}
                                                          exerciseNotes           = {this.state.exerciseNotes}
                                                          //editProgramBlock      = {this.editProgramBlock}
                                           />

                    /* showDayViewContainer = <span style={{display:this.state.showDayView}}>
                                                    <div>
                                                        <div className="weekContainer">
                                                            { this.renderWeekListTabs() }
                                                            &nbsp; &nbsp; <span className="addNewWeekLink" onClick={() => this.addNewWeekFromDayView()}>+ Week</span>
                                                        </div>
                                                    </div>
                                                    <div className="dayMainContainer">
                                                            <span className="dayContainer">
                                                                { this.renderDayListTabs() }
                                                                <span className="addNewDayLink" onClick={() => this.createProgramDay()}>+ Day</span>
                                                            </span>
                                                            { blocksList }
                                                    </div>
                                                    <span className="pull-left addNewBlockFooter">
                                                          <span className="blockFooterButtonNewBlock"
                                                                  onClick={this.handleAddBlock} >
                                                               + Add New Block
                                                          </span>
                                                          <span className = "blockFooterButtonFreeFormBlock"
                                                                 onClick={this.handleAddFreeFormBlock} >
                                                               + Add FreeForm Block
                                                          </span>
                                                    </span>
                                            <br/><br/>
                                    </span>*/
                }

            var showMonthViewContainer;
            var loadMonthViewData = this.state.loadMonthViewData;

            if(this.state.program_id != null && this.state.showMonthView === "inherit") {

                showMonthViewContainer = <span className = "trackMonthViewContainer"
                                               style={{display:this.state.showMonthView, border:"0px solid #000"}}>
                                                <CreateMonthViewWeek  className                 = "trackMonthViewWeek"
                                                                      setModalAlertProps        = {this.setModalAlertProps.bind(this)}
                                                                      showDayModalSimple        = {this.showDayModalSimple}
                                                                      getProgramDOMTree         = {this.getProgramDOMTree}
                                                                      setProgramName            = {this.setProgramName}
                                                                      loadMonthViewData         = {loadMonthViewData}
                                                                      debugAdvView              = {this.debugAdvView}
                                                                      saveProgram               = {this.saveProgram.bind(this)}
                                                                      duplicateProgramWeek      = {this.duplicateProgramWeekFromMonthView.bind(this)}
                                                                      deleteProgramWeek         = {this.deleteProgramWeekFromMonthView.bind(this)}
                                                                      getDayFromMonthView       = {this.getDayFromMonthView.bind(this)}
                                                                      showLoadingFooter         = {this.showLoadingFooter}
                                                                      openAddNewExerciseModal   = {this.openAddNewExerciseModal}
                                                                      editMonthViewExercise     = {this.handleEditMonthViewExercise}
                                                                      addBlock                  = {this.handleAddBlock}
                                                                      addFreeFormBlock          = {this.handleAddFreeFormBlock}
                                                                      program_id                = {this.state.program_id}
                                                                      //invokeCreateProgramDa    = {this.invokeCreateProgramDa}
                                                                      createProgramDay               = {this.createProgramDay} // replaced above prop
                                                                      updateMonthViewProgramBlock    = {this.updateMonthViewProgramBlock}
                                                                      invokeSortDaysMonthViewProgram = {this.invokeSortDaysMonthViewProgram}
                                                                      monthViewProgramBlock          = {this.state.month_view_program_block}
                                                                      cssWeekContainerHeight         = {this.state.cssWeekContainerHeight}
                                             />
                                         </span>
            }
            var show_title_button = "hidden";

            if(this.state.edit_title)
                show_title_button = "visible";

            var zoom_icon_color1 = "#666";
            var zoom_icon_color2 = "#666";
            var zoom_icon_color3 = "#666";
            var zoom_icon_color4 = "#666";

            var zoom_level = this.state.zoomLevel;
            var loading_text = this.state.loadingText;

            if(zoom_level === 1)
                zoom_icon_color1 = Colors.primary_color;
            else if(zoom_level === 2)
                zoom_icon_color2 = Colors.primary_color;
            else if(zoom_level === 3)
                zoom_icon_color3 = Colors.primary_color;
            else if(zoom_level === 4)
                zoom_icon_color4 = Colors.primary_color;

            let closeModalSimple          = () => this.setState({ showModalSimple: false }); //close simple modal window
            let closeModalChangeBlockName = () => this.setState({ showModalChangeBlockName: false }); //close simple modal window
            let closeModalSaveBlock       = () => this.setState({ showModalSaveBlock: false }); //close simple modal window
            let closeModalAddBlockTemplate= () => this.setState({ showModalAddBlockTemplate: false }); //close simple modal window
            let closeModalExerciseMatrix  = () => this.setState({ showModalExerciseMatrix: false }); //close matrix modal window
            let closeModalAlert           = () => this.setState({ showModalAlert: false }); //close simple modal window
            let closeModalSearchKeywords  = () => this.setState({ showModalSearchKeywords: false }); //close simple modal window
            let closeModalEditBlockName   = () => this.setState({ showModalEditBlockName: false }); //close simple modal window
            let closeModalProgramOverview = () => this.setState({ showModalProgramOverview: false }); //close simple modal window

            return (
                    <div className="Programs" id="multi" style={{backgroundColor:"transparent"}}>
                          <form>
                              <span className="viewContainer">
                                    { buttonShowExerciseDetails }
                              </span>
                              { showMonthViewLink }
                              <span style={{float: "right", position: "relative", top:"-6px", color: "#666", cursor: "pointer"}}
                                    onClick={this.showProgramOverview}>
                                    <span className="glyphicon glyphicon-th-list"/>&nbsp; Program Overview &nbsp;
                              </span>
                              <FormGroup controlId="program_name" bsSize = "large">
                                    <FormControl
                                        onChange={this.handleChangeProgramName}
                                        value={this.state.program_name}
                                        type = "text"
                                        bsClass="programTitle rowSize100Perc font24px"
                                    />

                                    <LoaderButton
                                          style={{visibility: show_title_button, float:"right", position:"relative", top:"-55px", left:"-10px", fontSize:18, paddingTop: 14, borderRadius:4, fontWeight: "bold", height:45, width: 80,  zIndex: 1100}}
                                          //bsSize="large"
                                          //disabled={!this.validateForm()}
                                          type        = "submit"
                                          isLoading   = {this.state.isLoading}
                                          text        = "Save"
                                          loadingText = "Saving…"
                                          onClick     = {this.handleEditTemplateTitle.bind(this)}
                                          //onClick = {() => this.handleSubmit()}
                                          //className=" programNavFooterBtn"
                                    />
                              </FormGroup>
                              <span style={{display:this.state.showMonthView}}>
                                  <div className="pull-right iconsIncreaseMonthViewDisplay">
                                        { /*}<span className="glyphicon glyphicon-plus addWeekIcon" onClick={this.addNewWeekFromMonthView.bind(this)}>
                                            <span className="addWeekIconLabel">Week </span> |&nbsp;
                                        </span> */ }
                                        <span className="glyphicon glyphicon-zoom-in font14px" style={{color: zoom_icon_color1}} onClick={() => this.setWeekContainerHeight(43)}/> &nbsp; &nbsp; &nbsp;
                                        <span className="glyphicon glyphicon-zoom-in"          style={{color: zoom_icon_color2}} onClick={() => this.setWeekContainerHeight(400)}/> &nbsp; &nbsp; &nbsp;
                                        <span className="glyphicon glyphicon-zoom-in font20px" style={{color: zoom_icon_color3}} onClick={() => this.setWeekContainerHeight(560)}/> &nbsp; &nbsp; &nbsp;
                                        <span className="glyphicon glyphicon-zoom-in font24px" style={{color: zoom_icon_color4}} onClick={() => this.setWeekContainerHeight(720)}/>

                                  </div>
                              </span>
                              <SideNavTimelineWeek  total_weeks  = { weeks }
                                                    week_current = { week_current }
                                                    showDayView  = { this.state.showDayView }
                                                    scrollYPos   = { this.state.scrollYPos }
                                                    handleWeekDropdownChange = { this.handleWeekDropdownChange }
                                                    addNewWeekFromMonthView  = { this.addNewWeekFromMonthView}
                              />
                              { /********** MAIN MONTH VIEW BODY **********/ }
                              { showMonthViewContainer }

                              { /********** MAIN DAY VIEW BODY **********/ }
                              { showDayViewContainer }
                          </form>

                            {this.state.showYouTubeModal ?
                                <ModalYouTubeVideo
                                    pageOverlay      = {this.state.pageOverlay}
                                    showYouTubeModal = {this.state.showYouTubeModal}
                                    exerciseId       = {this.state.exerciseId}
                                    youTubeId        = {this.state.youTubeId}
                                    onHide           = {closeModalExerciseMatrix}
                                    closeYouTubeWin  = {this.handleCloseYouTubeWin}
                                    exerciseDetailsObj = {this.state.exerciseDetailsObj}
                                    />
                            : null}

                            {this.state.showModalAlert ?
                                <ModalAlert
                                    onHide         = {closeModalAlert}
                                    alertFunction  = {this.alertFunction}     // custom function to call within modal
                                    alertAction    = {this.state.alertAction} // flag used for above function
                                    alertObject    = {this.state.alertObject} // vars used for above function
                                    showModalAlert = {this.state.showModalAlert}
                                    messageTitle   = {this.state.modalAlertTitleText}
                                    messageBody    = {this.state.modalAlertBodyText}
                                />
                            : null}

                          {this.state.showModalExerciseMatrix ?
                                <ModalExerciseMatrix
                                    show    = {this.state.showModalExerciseMatrix}
                                    onHide  = {closeModalExerciseMatrix}
                                    setExerciseProps      = {this.setExerciseProps}
                                    showYouTubeVideoModal = {this.showYouTubeVideoModal}
                                />
                           : null}

                          {this.state.showModalSearchKeywords ?
                                <ModalSearchKeywords
                                    show    = { this.state.showModalSearchKeywords}
                                    onHide  = { closeModalSearchKeywords }
                                    setExerciseProps = {this.setExerciseProps}
                                />
                          : null}

                          {this.state.showModalSimple ?
                              <ModalSimple
                                  isTemplate        = {this.state.isTemplate}
                                  show              = {this.state.showModalSimple}
                                  onHide            = {closeModalSimple}
                                  block_index       = {this.state.block_index}
                                  exercise_index    = {this.state.exercise_index}
                                  exercise_id       = {this.state.exercise_id}
                                  exercise_name     = {this.state.exercise_name}
                                  rest              = {this.state.rest}
                                  notes             = {this.state.notes}
                                  exerciseNotes     = {this.state.exerciseNotes}
                                  measure_adv_row1  = {1 /* perm id: Sets - currently static */}
                                  measure_adv_row2  = {this.state.measure_2_id}
                                  measure_adv_row3  = {this.state.measure_3_id}
                                  measure_adv_row4  = {3 /* perm id: Rest - currently static */ }
                                  youtube_id        = {this.state.youtube_id}
                                  advanced_metrics  = {this.state.advanced_metrics}
                                  showDayView       = {this.state.showDayView}
                                  //changeDropdownId         = {this.changeDropdownId.bind(this)}
                                  modalSimpleAction          = {this.state.modalSimpleAction}
                                  showProgressOverlay        = {this.showProgressOverlay.bind(this)}
                                  handleEditAdvancedExercise = {this.handleEditAdvancedExercise.bind(this)}
                                  handleAddAdvancedExercise  = {this.handleAddAdvancedExercise.bind(this)}
                                  handleEditAdvancedExerciseMonthView = {this.handleEditAdvancedExerciseMonthView.bind(this)}
                                  handleAddFreeFormExercise  = {this.handleAddFreeFormExercise.bind(this)}
                                  handleAddExerciseNotes     = {this.handleAddExerciseNotes.bind(this)}
                                  handleOpenExerciseMatrix   = {this.handleOpenExerciseMatrix.bind(this)}
                                  handleOpenModalSearchKeywords = {this.handleOpenModalSearchKeywords.bind(this)}
                              />
                          : null}
                          {this.state.showModalChangeBlockName ?
                              <ModalChangeBlockName
                                  show              = {this.state.showModalChangeBlockName}
                                  onHide            = {closeModalChangeBlockName}
                                  block_index       = {this.state.block_index}
                                  block_id          = {this.state.block_id}
                                  block_name        = {this.state.block_name}
                                  handleEditBlockName = {this.handleEditBlockName.bind(this)}
                              />
                          : null}

                          {this.state.showModalSaveBlock ?
                              <ModalSaveBlock
                                  show              = {this.state.showModalSaveBlock}
                                  onHide            = {closeModalSaveBlock}
                                  block_id          = {this.state.block_id}
                                  block_name        = {this.state.block_name}
                                  handleSaveBlockTemplate = {this.handleSaveBlockTemplate.bind(this)}
                              />
                          : null}

                          {this.state.showModalEditBlockName ?
                              <ModalEditBlockName
                                      show       = { this.state.showModalEditBlockName}
                                      onHide     = { closeModalEditBlockName }
                                      block_id   = {this.state.block_id}
                                      block_name = {this.state.block_name}
                                      handleFinishedModalEditBlockName = {this.handleFinishedModalEditBlockName.bind(this)}
                               />
                           : null}
                           {this.state.showModalProgramOverview ?
                               <ModalProgramOverview
                                   onHide         = {closeModalProgramOverview}
                                   showModalProgramOverview = {this.state.showModalProgramOverview}
                                   messageTitle   = {this.state.modalTitleText}
                                   clientId       = {this.props.clientId}
                                   modalProgramId = {this.state.modalProgramId}
                               />
                           : null}

                          {this.state.showModalAddBlockTemplate ?
                              <ModalAddBlockTemplate
                                    show              = {this.state.showModalAddBlockTemplate}
                                    onHide            = {closeModalAddBlockTemplate}
                                    block_id          = {this.state.block_id}
                                    block_name        = {this.state.block_name}
                                    //handleSubmitModalAddBlockTemplate = {this.handleSubmitModalAddBlockTemplate.bind(this)}
                                    handleOpenModalEditBlockName    = {this.handleOpenModalEditBlockName.bind(this)}
                                    handleAddBlockTemplateToProgram = {this.handleAddBlockTemplateToProgram.bind(this)}
                                    handleSaveBlockTemplate         = {this.handleSaveBlockTemplate.bind(this)}
                              />
                           : null}

                            <div className="loadingBarContainer" style={{backgroundColor:"black", display:this.state.loadingBarContainer}}>
                                <span className="loadingBarMessage">
                                    <span className="glyphicon glyphicon-bullhorn"></span>
                                &nbsp; {loading_text} Data...
                                </span>
                                <span className="loadingBarFooter"></span>
                                <span className="loadingBarBackground"></span>
                            </div>
                    </div>
            );
        } // end if
        else
            return null;
    }
}



// WEBPACK FOOTER //
// ./src/screens/program/Program.js